module.exports = __webpack_public_path__ + "static/media/advantagesImage.4c8569e8.png";